// Resolves a Box Jump-To selection against the currently visible rows.
//   null → skip: no active jump, or data isn't ready yet (loading / empty) —
//          the caller must NOT flag "not found" here, or it fires spuriously
//          during a refetch or a division switch.
//   -1   → the box is genuinely absent from a loaded, non-empty table.
//   >= 0 → the row index to select.
// boxNumber is string-normalized because the /boxNumbers source and the bus-block
// rows don't guarantee the same type.
export const resolveBoxJump = ({ boxJumpTo, rows, loadingData }) => {
  if (!boxJumpTo) return null;
  if (loadingData || !Array.isArray(rows) || rows.length === 0) return null;
  const target = String(boxJumpTo).trim();
  return rows.findIndex((row) => String(row.boxNumber).trim() === target);
};
